// No published KUR insights exist yet. Add entries here and the homepage
// Insights section appears automatically; while empty it renders nothing.
// Shape: { id, category, title, excerpt, date: "YYYY-MM-DD", href, image? }

export const insights = [];
